import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-254f1d10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flexAlign" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 5px"} }, "-", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#F56C6C","margin-right":"3px"} }, "*", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("项目负责人")
const _hoisted_5 = ["value", "onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  traget: "_blank",
  href: "/template/项目管理系统售前流程2025.6.26.docx",
  style: {"color":"blue"}
}, "售前流程资料", -1))
const _hoisted_7 = {
  slot: "footer",
  class: "flexCenter"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("提 交")

import { reactive,ref,onMounted } from 'vue'
	import { ElMessage } from 'element-plus'
	import { requestAddProject,xmUser,xmDetails } from '@/api/xmApi'
    import { requestAllSelfUserGroup } from '@/api/api'
	import { requestGetAllConfig } from '@/api/configApi'
	interface formType {
		uuid: string
		code: string
		projectname: string
		startdate: string
		enddate: string
		fzrid: any
		fzrname: string
		userlist: string
		remark: string
		type1: number
		status: number
	}
	
export default /*#__PURE__*/_defineComponent({
  name: 'AddProject',
  props: {
		uuid:String
	},
  emits: ['cancel'],
  setup(__props, { emit }) {

const props = __props

	
	const xmUserList = ref<number[]>([])
	const addForm = ref<formType>({
		uuid:'',
		code:'',
		projectname:'',
		startdate:'',
		enddate:'',
		fzrid:'',
		fzrname:'',
		userlist:'',
		remark:'',
		type1:1,
		status:1,
		sf:''
	})
	const usergroupLists = ref<any[]>([])
	const userLists = ref<any[]>([])
	const sfLists = ref<any[]>([])
	
	onMounted(()=>{
		getDate();
		getUserList()
		getsfLists()
	})
	const getDate = () => {
		let date = new Date();
		let YY = date.getFullYear() + '-';
		let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
		addForm.value.startdate = `${YY}${MM}${DD}`


		
		requestAllSelfUserGroup({}).then((res:any)=>{
			if(res.status === 1){
				usergroupLists.value=res.datalist;
			}
		})
	}
	const ksxzclick = (val: any) =>{
		xmUserList.value=val.split(",")
	}
	// 选择项目负责人后，记录负责人姓名用于列表展示
	const onFzrChange = (val: any) =>{
		const u = userLists.value.find((x:any)=>x.id == val)
		addForm.value.fzrname = u ? u.name : ''
	}
	const getsfLists = () =>{
		requestGetAllConfig({
			type:"省份"
		}).then((res:any)=>{
			if(res.status === 1){
				sfLists.value = res.datalist
			}
		})
	}

	const getUserList = () =>{
		xmUser().then((res:any)=>{
			if(res.status === 1){
				userLists.value = res.datalist
				if(props.uuid != ""){
					xmDetails({
						uuid:props.uuid
					}).then((ress:any)=>{
						if(ress.status === 1){
							addForm.value = ress.datalist[0]
							addForm.value.status = parseInt(ress.datalist[0].status)
							addForm.value.type1 = parseInt(ress.datalist[0].type1)
							xmUserList.value = ress.datalist[0].userlist.split(",")
							// 回显项目负责人：保持与下拉选项一致的值类型（字符串），避免类型不匹配导致显示 id 而非名称
							const rid = ress.datalist[0].fzrid
							addForm.value.fzrid = (rid && rid !== "0" && rid !== 0) ? rid : ''
							addForm.value.fzrname = ress.datalist[0].fzrname || ''
						}
					})
				}
			}
		})
	}
	const submit = () =>{
		addForm.value.userlist = xmUserList.value.join(",")
		if(addForm.value.projectname === ""){
			ElMessage.error("请输入项目名称");
			return
		}
		// 项目负责人为必填项
		if(!addForm.value.fzrid){
			ElMessage.error("请选择项目负责人");
			return
		}
		if(addForm.value.startdate === ""){
			ElMessage.error("请选择项目开始时间");
			return
		}
		if(addForm.value.enddate === ""){
			ElMessage.error("请选择项目结束时间");
			return
		}
		if(addForm.value.userlist === ""){
			ElMessage.error("请选择项目可见人");
			return
		}
		console.log(addForm.value);
		// 兜底：已选负责人但姓名为空时，按人员列表补全，保证列表能显示负责人姓名
		if(!addForm.value.fzrname && addForm.value.fzrid){
			const fu = userLists.value.find((x:any)=>x.id == addForm.value.fzrid)
			if(fu) addForm.value.fzrname = fu.name
		}
		requestAddProject({
			uuid:addForm.value.uuid,
			code:addForm.value.code,
			projectname:addForm.value.projectname,
			startdate:addForm.value.startdate,
			enddate:addForm.value.enddate,
			fzrid:addForm.value.fzrid,
			fzrname:addForm.value.fzrname,
			userlist:addForm.value.userlist,
			remark:addForm.value.remark,
			type1:addForm.value.type1,
			status:addForm.value.status,
			sf:addForm.value.sf
		}).then((res:any)=>{
			ElMessage({
				message: res.msg,
				type: 'success',
				duration: 500
			});
			setTimeout(()=>{
				emit("cancel",1)
			},500)
		})
	}
	const cancelProject = () =>{
		emit("cancel")
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      "label-width": "100px",
      "show-message": false,
      style: {"background-color":"#fff","padding":"30px 20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "项目编号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: addForm.value.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addForm.value.code) = $event)),
              placeholder: "请输入项目编号",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (submit()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "项目名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: addForm.value.projectname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addForm.value.projectname) = $event)),
              placeholder: "请输入项目名称",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (submit()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "项目时间" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_date_picker, {
                modelValue: addForm.value.startdate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addForm.value.startdate) = $event)),
                type: "date",
                placeholder: "开始时间",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"]),
              _hoisted_2,
              _createVNode(_component_el_date_picker, {
                modelValue: addForm.value.enddate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addForm.value.enddate) = $event)),
                type: "date",
                placeholder: "结束时间（必填）",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              filterable: "",
              modelValue: addForm.value.fzrid,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addForm.value.fzrid) = $event)),
              onChange: onFzrChange,
              placeholder: "请输入并搜索选择（必填）",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.id,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "项目可见人" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              filterable: "",
              modelValue: xmUserList.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((xmUserList).value = $event)),
              multiple: "",
              placeholder: "请选择",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.id,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "快速选择" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usergroupLists.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                value: item.useridlist,
                class: "ksxz",
                onClick: ($event: any) => (ksxzclick(item.useridlist))
              }, _toDisplayString(item.gruopname), 9, _hoisted_5))
            }), 256))
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "备注" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: addForm.value.remark,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addForm.value.remark) = $event)),
              placeholder: "请输入备注",
              onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (submit()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "项目类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: addForm.value.type1,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addForm.value.type1) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "项目售前",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "项目售中",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "项目售后",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "公司内部项目",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "周计划投产",
                  value: 5
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (addForm.value.type1==1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "售前流程资料"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { label: "省份" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: addForm.value.sf,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addForm.value.sf) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sfLists.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.value,
                    value: item.id,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "状态" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: addForm.value.status,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addForm.value.status) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "进行中",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "关闭",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "完成",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        onClick: _cache[13] || (_cache[13] = ($event: any) => (cancelProject())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[14] || (_cache[14] = ($event: any) => (submit())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})